import React from 'react';

const Card = ({ title, subtitle, right, children, className = '', glow = false }) => (
  <div className={`card ${glow ? 'card-glow' : ''} ${className}`}>
    {(title || right) && (
      <div className="card-header">
        <div>
          {title && <div className="card-title">{title}</div>}
          {subtitle && <div className="card-subtitle">{subtitle}</div>}
        </div>
        {right && <div>{right}</div>}
      </div>
    )}
    {children}
  </div>
);

export default Card;
